import { getMomentTz } from "@dexteel/mesf-core";
import { isNil } from "lodash-es";
import { useState } from "react";
import { unLinkCasterProcess } from "../../processes/repositories/CasterRepository";
import { useDataEntryContext } from "../context/reducer.provider";
import { useTimerContext } from "../context/timer.provider";
import { Process } from "../models/caster.models";
import { useCasterDataEntryActions } from "./useCasterDataEntryActions";
const moment = getMomentTz();

export const useLinkUnlinkProcess = (process: Process) => {
  const { state, actions } = useDataEntryContext();
  const { refreshData } = useCasterDataEntryActions();
  const { resume } = useTimerContext();

  const [showLinkModal, setShowLinkModal] = useState(false);
  const [showUnlinkModal, setShowUnlinkModal] = useState<{
    show: boolean;
    message: string;
  }>({ show: false, message: "" });

  //Link
  const handleLinkHeat = () => {
    actions.setDEProcess({ ...state.deProcess, process });
    setShowLinkModal(true);
  };

  //Unlink
  const unlinkProcess = async () => {
    const dateOpen = moment(process.LadleOpen).format("YYYY/MM/DD HH:mm");
    setShowUnlinkModal({
      show: true,
      message:
        "The heat " +
        process.HeatName +
        " from " +
        dateOpen +
        " will be unlinked.  Do you want to continue?",
    });
  };

  const handleUnlinkHeat = async (value?: string) => {
    setShowUnlinkModal({ show: false, message: "" });
    if (value !== "OK") {
      resume();
      return;
    }
    await unLinkProcessData();
    resume();
  };

  const unLinkProcessData = async () => {
    if (isNil(process) || isNil(process.ProcessId) || isNil(process.HeatId)) {
      actions.setErrorMessage("Process not found");
      resume();
      return;
    }

    actions.setIsDataLoading(true);

    try {
      const resp = await unLinkCasterProcess(process?.ProcessId);
      if (resp.ok) {
        actions.setNotificationMessage("Process unlinked successfully");
        await refreshData();
      } else {
        actions.setErrorMessage(resp.message);
      }
    } catch (error) {
      actions.setErrorMessage("Error unlinking process");
    } finally {
      actions.setIsDataLoading(false);
    }
  };

  const handleSetShowLinkModal = (show: boolean) => {
    setShowLinkModal(show);
    if (!show) {
      resume();
    }
  };

  return {
    unlinkProcess,
    handleLinkHeat,
    handleUnlinkHeat,
    showLinkModal,
    showUnlinkModal,
    setShowLinkModal: handleSetShowLinkModal,
    setShowUnlinkModal,
  };
};
